import { AzureSqlDWLinkedService } from '../linkedservice/azure-sql-dw.linkedservice';
import { Metamodel } from '../base/model';
import { IModel, type IAttribute } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.synapseTableDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.AzureSynapseAnalytics),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.AzureSynapseAnalytics)
    ],
    constraints: {
        linkedService: {
            model: AzureSqlDWLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureSqlDWTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static DATABASE: IAttribute;
    @Metamodel.attribute({
        display: shellStringResources.Database,
        templatable: true,
        association: 'DATABASE'
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
